export default __webpack_public_path__ + "static/featured_image_glossary-55ae194fc07f723bbbf69785c37006e4.jpg";